import openSocket from 'socket.io-client';
import axios from 'axios';
import { getBaseUrl } from "./actions/urls";

let staging = false;
// if (document.location.origin.indexOf('commandcentrestage') > -1 || document.location.hostname === 'localhost') {
// 	staging = true;
// } else {
// 	staging = false;
// }

// Socket Variables
let socket1;

function openSockets() {

	let token = localStorage.getItem("token");
	var streamUrl = `https://socialdeck.circussocial.com?access-token=${token}`;

	socket1 = openSocket(streamUrl, { "transports": ["websocket"], "autoConnect": false, "path": "/stream/socket.io", forceNew: true });
	socket1.open();
}

// Get Comments 
function getComments(filters) {
	let token = localStorage.getItem("token");
	filters += '&access-token=' + token;
	filters += '&recordsPerPage=1000';

	let res = axios.post(`${getBaseUrl()}/search`, filters, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => res.data)
	return res;
}

// Get ES Posts 
function getPosts(filters, recordsPerPage) {
	let token = localStorage.getItem("token");
	filters += '&access-token=' + token;
	filters += '&recordsPerPage=' + recordsPerPage;

	let res = axios.post(`${getBaseUrl()}/search`, filters, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => res.data)
	return res;
}

// Get Country Sentiments Breakup
function getCountrySentimentsBreakup(filters) {
	filters += '&aggs=country-sentiments-breakup';
	return getPosts(filters, 50);
}

// Get Volume of Conversation
function getVolumeOfConversation(filters) {
	let token = localStorage.getItem("token");
	filters += '&access-token=' + token;

	let res = axios.post(`${getBaseUrl()}/sk2/cc/widgets/v2/share-of-voice`, filters, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => res.data)

	return res;
}

function login(data) {
	let params = {
		'username': data.username,
		'password': data.password
	};
	let req = axios.request({
		method: 'POST',
		url: staging ? 'https://6hglfnkcv7.execute-api.ap-southeast-1.amazonaws.com/dev/auth/v1/signin' : 'https://qy6gry1pzg.execute-api.ap-southeast-1.amazonaws.com/prod/auth/v1/signin',
		data: params
	}).then(response => {
		localStorage.setItem('jwt-token', response.data['jwt-token']);
		localStorage.setItem("token", response.data['token_md5']);
		return response;
	}).catch(err => {
		console.log(err);
	})

	return req;
}

// Function to Email Posts/Screenshots
function sendEmail(params) {
	let token = localStorage.getItem("token");
	
	let req = axios.post(`${getBaseUrl()}/cc/email/screenshot?access-token=${token}`, params).then(response => {
		return response;
	})
	
	return req;
}

function saveFilter(filter){
	let token = localStorage.getItem("token");
	// PUT is for updating the existing filter for a widget
	// POST is for creating a filter if it does not exist in the db for the given widget
    const method = filter.is_default ? "POST" : "PUT";
    const data = filter.is_default
        ? { widget_id: filter.id, filter_json: filter.filter_json.filter_json }
        : { id: filter.id, filter_json: filter.filter_json.filter_json };

    return axios
        .request({
            method,
            url: `${getBaseUrl()}/cc_filters?access-token=${token}`,
            data
        })
        .then(response => {
            return response.data;
        })
        .catch(err => console.log(err));
}

function turnSocketOff() {
	if (socket1) {
		socket1.close();
	}
}

function subscribeToRawData(filter, cb) {
	socket1.emit('subscribeToRawData', filter, function (response) {
	});
	socket1.on('message', data => cb(null, data));
}

const ssoLogin = () => {
	sessionStorage.removeItem('ssoLoginAttempted')
	// let url = "https://fedauth.pg.com/idp/startSSO.ping?PartnerSpId=urn:auth0:circussocial:PG";
	let url = staging
        ? "https://fedauthtst.pg.com/idp/startSSO.ping?PartnerSpId=urn%3Aauth0%3Acircussocial%3APG"
		: "https://fedauth.pg.com/idp/startSSO.ping?PartnerSpId=urn:auth0:circussocial:PG";
	// console.log(staging)
	// console.log(url)
	window.open(url, "_self");
}

const ssoLogout = () => {
	localStorage.clear();
	sessionStorage.clear();
	sessionStorage.setItem("ssoLoggedOut", true);
	// let url = "https://fedauth.pg.com/idp/startSLO.ping?TargetResource=https://fedauth.pg.com/ext/logout";
	let url = staging
        ? "https://fedauthtst.pg.com/idp/startSLO.ping?TargetResource=https://fedauthtst.pg.com/ext/logout"
		: "https://fedauth.pg.com/idp/startSLO.ping?TargetResource=https://fedauth.pg.com/ext/logout";
	// console.log(url)
	window.open(url, "_self");
}

const tracking = (data) => {
	let token = localStorage.getItem("token");
    let { id, title } = JSON.parse(localStorage.getItem("cc"));
	let { company_identifier } = JSON.parse(localStorage.getItem("meta")).company;
    if (company_identifier !== "toyotasg") return;
    data.event_type = "commandcenter";
    data.event_subtype = "click";
    data.cc_id = id;
    data.cc_name = title;
    let res = axios
        .post(`${getBaseUrl()}/tracking/cc/log-event?access-token=${token}`, data, {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((res) => res.data);
    return res;
}

const iAmLive = (type) => {
	let token = localStorage.getItem("token");
	let data = {};
	if (JSON.parse(localStorage.getItem("cc")) === null || JSON.parse(localStorage.getItem("meta")) === null)
        return new Promise((success) => {
            success([]);
        });

    let { id, title } = JSON.parse(localStorage.getItem("cc"));
    let { company_identifier } = JSON.parse(localStorage.getItem("meta")).company;
    if (company_identifier !== "toyotasg")
        return new Promise((success) => {
            success([]);
        });

    data.cc_id = id;
	data.cc_name = title;
	if(type) data.type = type
    let res = axios
        .post(`${getBaseUrl()}/tracking/cc/iamalive?access-token=${token}`, data, {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((res) => res.data);
    return res;
}

export {
	openSockets,
	saveFilter,
	subscribeToRawData,
	login,
	getPosts,
	getComments,
	turnSocketOff,
	sendEmail,
	getCountrySentimentsBreakup,
	getVolumeOfConversation,
	ssoLogin,
	ssoLogout,
	tracking,
	iAmLive
};